import { classes } from 'src/utils'

type Props = {
  label: string
  className?: string
}

export function Title(props: Props) {
  return (
    <h1
      className={classes(
        'text-3xl font-light capitalize text-slate-600',
        props.className,
      )}
    >
      {props.label}
    </h1>
  )
}
